import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { UtilService } from '../services/util.service';
import { ApiService } from '../services/api.service';
import { Router } from '@angular/router';

export const mfaAuthGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const utilService = inject(UtilService);
  const apiService = inject(ApiService);
  const router = inject(Router);

  const user = authService.getUser();
  
  // If no user data, redirect to login
  if (!user) {
    utilService.navigate('/');
    return false;
  }
  
  // Check if user has completed MFA verification
  if (user.mfaVerified === true) {
    return true;
  }
  
  // If MFA is required but not verified, redirect to MFA login
  // But first check if MFA is actually enabled for this user
  if (user.isMfaEnabled === true && user.mfaVerified !== true) {
    router.navigate(['/mfa-login']);
    return false;
  }
  
  // Fail closed: deny access unless explicitly verified
  router.navigate(['/mfa-login']);
  return false;
};